import { configureStore } from "@reduxjs/toolkit";

import rootReducer from "./rootReducer";

export const store = configureStore({
  reducer: rootReducer,

  devTools: process.env.ENABLE_REDUX_DEV_TOOLS,
});
